import { render, staticRenderFns } from "./ModalCloseButton.vue?vue&type=template&id=afe51182&scoped=true&"
import script from "./ModalCloseButton.vue?vue&type=script&lang=js&"
export * from "./ModalCloseButton.vue?vue&type=script&lang=js&"
import style0 from "./ModalCloseButton.vue?vue&type=style&index=0&id=afe51182&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe51182",
  null
  
)

export default component.exports